/* Theme custom file */
// ENG-4116 -- hide the Yuma floating bubble, keep the chat reachable from the CTA.
//
// Yuma offers no native way to start hidden. Its documented API exposes a `hide`
// command, but it is one-way: once hidden the widget is torn out of the DOM and
// neither `open` nor `show` brings it back, not even after a full page reload.
// Pushing `hide` on load would therefore leave the "Nous contacter" button dead.
//
// So visibility is driven off the iframe width instead. Yuma sizes #yuma-widget to
// 72px while collapsed and expands it when the conversation opens, which makes the
// width a reliable proxy for the launcher state. Ported from the previous theme
// (tb-shopify-web-v2/assets/yuma-launcher.js, commit 595940dcd).
(function () {
  // The section guards its own inline init the same way, in case the theme editor
  // ends up with more than one instance of it on a page.
  if (window.__yumaLauncherInit) return;
  window.__yumaLauncherInit = true;

  var COLLAPSED_WIDTH = 72;

  function setup(frame) {
    frame.classList.add('yuma-launcher-hidden');

    new MutationObserver(function () {
      frame.classList.toggle('yuma-launcher-hidden', parseInt(frame.style.width) <= COLLAPSED_WIDTH);
    }).observe(frame, { attributes: true, attributeFilter: ['style'] });
  }

  var frame = document.getElementById('yuma-widget');
  if (frame) {
    setup(frame);
    return;
  }

  // Yuma loads async, so #yuma-widget is usually not in the DOM yet.
  new MutationObserver(function (mutations, obs) {
    var f = document.getElementById('yuma-widget');
    if (f) {
      obs.disconnect();
      setup(f);
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
